import React, { useState, useEffect } from 'react';
import { marketingAPI } from '../services/api';
import './Marketing.css';

const Marketing = () => {
  const [ads, setAds] = useState([]);
  const [promos, setPromos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('ads');
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', detail: '', status: 'active' });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const response = await marketingAPI.getAll();
      if (response.data.success) {
        setAds(response.data.data.ads || []);
        setPromos(response.data.data.promo || []);
      }
    } catch (error) {
      console.error('Failed to load marketing data', error);
    }
  };

  const openModal = (type, item = null) => {
    setModalType(type);
    setEditingItem(item);
    setFormData(item ? { name: item.name, detail: item.detail, status: item.status } : { name: '', detail: '', status: 'active' });
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      if (editingItem) {
        await marketingAPI.update(editingItem.id, { ...formData, type: modalType });
      } else {
        await marketingAPI.create({ ...formData, type: modalType });
      }
      setShowModal(false);
      loadData();
    } catch (error) {
      console.error('Failed to save', error);
    }
  };

  const handleDelete = async (item) => {
    try {
      await marketingAPI.delete(item.id);
      loadData();
    } catch (error) {
      console.error('Failed to delete', error);
    }
  };

  return (
    <div className="marketing-page">
      <div className="page-grid">
        <div className="card">
          <div className="card-header">
            <div className="card-icon">📊</div>
            <div>
              <div className="card-title">Ads en cours</div>
              <div className="card-subtitle">Campagnes Meta actives</div>
            </div>
            <button className="add-btn" onClick={() => openModal('ads')}>+</button>
          </div>
          <div className="card-list">
            {ads.length === 0 ? (
              <div className="empty-state">Aucune campagne</div>
            ) : (
              ads.map((item) => (
                <div key={item.id} className="list-item" onClick={() => openModal('ads', item)}>
                  <div className={`status-dot ${item.status}`}></div>
                  <div className="item-info">
                    <div className="item-name">{item.name}</div>
                    <div className="item-detail">{item.detail}</div>
                  </div>
                  <span className="badge ads">ADS</span>
                  <button className="delete-btn" onClick={(e) => { e.stopPropagation(); handleDelete(item); }}>×</button>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <div className="card-icon">🎳</div>
            <div>
              <div className="card-title">Promotions en cours</div>
              <div className="card-subtitle">Offres actives</div>
            </div>
            <button className="add-btn" onClick={() => openModal('promo')}>+</button>
          </div>
          <div className="card-list">
            {promos.length === 0 ? (
              <div className="empty-state">Aucune promotion</div>
            ) : (
              promos.map((item) => (
                <div key={item.id} className="list-item" onClick={() => openModal('promo', item)}>
                  <div className={`status-dot ${item.status}`}></div>
                  <div className="item-info">
                    <div className="item-name">{item.name}</div>
                    <div className="item-detail">{item.detail}</div>
                  </div>
                  <span className="badge promo">PROMO</span>
                  <button className="delete-btn" onClick={(e) => { e.stopPropagation(); handleDelete(item); }}>×</button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>{editingItem ? 'Modifier' : 'Nouveau'} {modalType === 'ads' ? 'campagne' : 'promotion'}</h3>
            <div className="form-group">
              <label>Nom</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ex: Promo Ete 2026"
              />
            </div>
            <div className="form-group">
              <label>Detail</label>
              <input
                type="text"
                value={formData.detail}
                onChange={(e) => setFormData({ ...formData, detail: e.target.value })}
                placeholder="Ex: 300 MAD/j"
              />
            </div>
            <div className="form-group">
              <label>Statut</label>
              <select
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                <option value="active">Actif</option>
                <option value="paused">En pause</option>
                <option value="off">Termine</option>
              </select>
            </div>
            <div className="modal-actions">
              <button className="btn-primary" onClick={handleSave}>Enregistrer</button>
              <button className="btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Marketing;